<div class="sku-image-dialog">
    <div class="sku-image-dialog__header">
        <button type="button" class="btn-close" mat-dialog-close></button>
    </div>
    <div class="sku-image-dialog__body mt-2">
        <iframe class="sku-image-dialog__iframe" id="pdf" name="pdf" [src]="getSourceURL(fileUrl)"></iframe>
    </div>
</div>


